import React, { useEffect, useState } from 'react';
import Col from 'antd/es/col';
import Card from 'antd/es/card';
import Typography from 'antd/es/typography';
import Row from 'antd/es/row';
import Form from 'antd/es/form';
import Button from 'antd/es/button';
import { useTranslation } from 'react-i18next';
import { useDebouncedCallback } from 'use-debounce/esm';
import { useHistory } from 'react-router';
import { requiredField } from 'common/helpers/filed-rules';
import { objectToQuery, queryToObject } from 'common/helpers/filters.helper';
import { ETrainerFilterCardsFilters, TrainerListFilterCard } from 'entities/Trainer/components/List/TrainerListFilterCard';
import { TrainerList } from 'entities/Trainer/components/List/TrainerList';
import { ETrainerActionTypes, ITrainerAcademyRequestCollectionFilter, ITrainerModel } from 'entities/Trainer/Trainer.models';
import { communicationTeam, ITeamConnectedProps } from 'entities/Team/Team.communication';
import { TrainerSelector } from 'entities/Trainer/components/Selectors/TrainerSelector';

interface IProps {
  academyId?: string;
  teamId: string;
}

const initState = {
  search: undefined
};

type AllProps = IProps & ITeamConnectedProps;

const TeamAcademyPageTrainersComponent: React.FC<AllProps> = props => {
  const { t } = useTranslation();
  const history = useHistory();
  const { addTrainerToTeamAction, academyId, teamId, teamAction } = props;
  const [addTrainerForm] = Form.useForm();
  const [renderIndex, setRenderIndex] = useState(Math.random());
  const [state, setState] = useState<Partial<ITrainerAcademyRequestCollectionFilter> | undefined>({
    ...initState,
    ...queryToObject<Partial<ITrainerAcademyRequestCollectionFilter>>(initState)
  });

  const debPush = useDebouncedCallback((val: any) => {
    history.replace(val);
  }, 300);

  useEffect(() => {
    debPush.callback({ search: objectToQuery(state) });
  }, [state]);

  const onAddTrainer = (form: { trainers: ITrainerModel[] }) => {
    if (teamId) {
      addTrainerToTeamAction({ id: teamId, trainerModels: form.trainers });
      addTrainerForm.resetFields();
    }
  };

  return (
    <Row className="width-full">
      {academyId && (
        <Col span={24}>
          <Card className="px-3 mt-5" bordered={false}>
            <Typography.Title className="mb-5" level={4}>
              {t('Add trainer')}
            </Typography.Title>
            <Row>
              <Form
                form={addTrainerForm}
                onFinish={onAddTrainer}
                name="add-trainer-to-team"
                layout="horizontal"
                className="width-full"
              >
                <Row className="width-full" justify="space-between">
                  <Col xs={24} md={17}>
                    <Form.Item name="trainers" rules={[requiredField]}>
                      <TrainerSelector
                        mode="multiple"
                        excludeTeam={teamId}
                        size="large"
                        disabled={teamAction?.loading}
                        academyId={academyId}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={6}>
                    <Button
                      block
                      htmlType="submit"
                      type="primary"
                      size="large"
                      disabled={teamAction?.loading}
                      loading={teamAction?.loading}
                    >
                      {t('Link')}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Row>
          </Card>
        </Col>
      )}

      <Col xs={24}>
        <Row className="width-full" key={renderIndex}>
          <TrainerListFilterCard
            enabledFilters={[ETrainerFilterCardsFilters.Search]}
            filter={state}
            onFilterChange={partialFilter => setState({ ...state, ...partialFilter })}
          />
        </Row>
        <Row>
          <TrainerList
            className="mt-5 academy-view-page__trainers__list"
            teamId={teamId}
            academyId={academyId}
            actionType={ETrainerActionTypes.UnlinkFromTeam}
            clearFilter={() => {
              setState({ ...initState });
              setRenderIndex(Math.random());
            }}
            elementId="basicLayout"
            filter={state}
          />
        </Row>
      </Col>
    </Row>
  );
};

export const TeamAcademyPageTrainers = communicationTeam.injector(TeamAcademyPageTrainersComponent);
